<template>
  <div v-if="hasAuth('CirculationProfile')">
    <list-container
      :header="translate('circulationProfileSchema.flows')"
      v-show="!$route.params.id"
      :showSearch="true"
      @search="searchCirculationProfiles"
    >
      <template v-slot:commands>
        <excel-exporter
          table-id="circulationProfileSchemaExport"
          :columns="columns"
          url="/CirculationProfileSchema/get"
          modelName="CirculationProfileSchema"
        ></excel-exporter>
        <button
          class="btn btn-primary"
          @click="
            $router.push({
              name: 'CirculationProfileSchemaDetail',
              params: { id: '000000000000000000000000' },
            })
          "
        >
          {{translate('circulationProfileSchema.newFlow')}}
        </button>
      </template>

        <list
          ref="circulationProfiles"
          :columns="columns"
          url="/CirculationProfileSchema/get"
          :predicate="predicate"
          :filter="filter"
          modelName="CirculationProfileSchema"
          orderBy="IsActive desc, Name"
        >
        </list>

    </list-container>
    <router-view v-if="$route.params.id"/>
  </div>
  <div v-else class="alert alert-danger">
    {{translate('errors.notAuthorizedForTheProcess')}}
  </div>
</template>

<script>
import Vue from "vue";
import list from "../components/List.vue";
import listContainer from "../components/ListContainer.vue";
import ExcelExporter from "../components/ExcelExporter.vue";
import i18n from "../i18n";

export default {
  data() {
    return {
      predicate: "",
      filter: { DepartmentIds : this.hasAuth("Admin") ? [] : this.$root?.$data?.login?.User?.DepartmentIds ?? [] },
      searchText: "",
      columns: [
        {
          Key: "Name",
          Title: this.translate('circulationProfileSchema.flowName'),
        },
        {
          Key: "TargetSystems",
          Title: this.translate('circulationProfileSchema.targetSystemColumn'),
          Content(i) {
            if (i.TargetSystems)
              return Vue.filter('stripHTML')(i.TargetSystems.map(x => x.Name).join(', '))

            return '';
          },
        },
        {
          Key: "Department",
          Title: "Departman",
          Content(i) {
            return i.Department ? i.Department?.Name.cleanHtml() : i18n.t('circulationProfileSchema.departmentIndependent');
          }
        },
        {
          Key: "IsActive",
          Title: this.translate('targetSystemImport.active'),
          Class: "text-center",
          // Style: "width:1px",
          Content(i) {
            return Vue.filter("checkicon")(i.IsActive);
          },
        },
      ],
    };
  },
  components: {
    list,
    ExcelExporter,
    listContainer,
  },
  methods: {
    searchCirculationProfiles(text) {
      this.predicate = ` Name.ToLower().Contains("${text.toLowerCase()}")`;

      this.$refs.circulationProfiles.predicate = this.predicate;
      this.$refs.circulationProfiles.getData();
    },
  },
};
</script>
<style scoped>
.col-search {
  margin-top: 20px;
  float: right;
  clear: both;
  width: 30%;
}
.mbm {
  margin-bottom: 10px !important;
}
.input-group-btn {
  padding-left: 10px;
  padding-top: 6px;
  padding-right: 10px;
  background-color: #e5e5e5;
  color: #777777;
  border-color: #e5e5e5;
  border: 1px solid #e5e5e5;
  position: relative;
  font-size: 0;
  white-space: nowrap;
}
</style>